import React from 'react';
import { Progress } from './ui/progress';
import { cn } from '../lib/utils';

export default function ProgressBar({ value, max, label, color = 'lime', showPercentage = true, percentAtBar = false }) {
  const percentage = (value / max) * 100;
  
  const colorClasses = {
    gray: 'bg-gray-500',
    lime: 'bg-lime-500',
    cyan: 'bg-cyan-500',
    orange: 'bg-orange-500',
    purple: 'bg-purple-500',
    yellow: 'bg-yellow-500',
    teal: 'bg-teal-500',
    rose: 'bg-rose-500',
    blue: 'bg-blue-500',
    emerald: 'bg-emerald-500',
    pink: 'bg-pink-500'
  };

  return (
    <div className="space-y-1">
      {label && !percentAtBar && (
        <div className="flex items-center justify-between">
          <span className="text-sm text-gray-300">{label}</span>
          {showPercentage && (
            <span className={cn("text-sm font-semibold", `text-${color}-400`)}>
              {percentage.toFixed(1)}%
            </span>
          )}
        </div>
      )}
      {percentAtBar && showPercentage && (
        <div className="text-center">
          <span className={cn("text-sm font-bold", `text-${color}-400`)}>
            {percentage.toFixed(1)}%
          </span>
        </div>
      )}
      <div className="relative h-3 bg-black/40 rounded-full overflow-hidden border border-lime-500/20">
        <div
          className={cn(
            "h-full rounded-full transition-all duration-1000 ease-out",
            colorClasses[color]
          )}
          style={{
            width: `${Math.min(percentage, 100)}%`,
            boxShadow: `0 0 20px rgba(168, 213, 48, 0.5)`
          }}
        />
      </div>
    </div>
  );
}
